// extracted by mini-css-extract-plugin
export default {"modal":"limited-stock-modal_modal__4d9b3"};